/**
 * @author liuxd24
 * @create date 2022-12-06
 * @modify date 2022-12-06
 * @desc 多bu目录页面
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel } from '../bases';
@BindAll()
export class ChannelsController {
  Model = new BaseModel({ type: 'object' });
  @computed
  get cardData() {
    return lodash.get(
      this.getListData,
      [this.channelActive, 'children', this.productActive, 'children'],
      [],
    );
  }
  @computed
  get slideCode() {
    return lodash.get(
      this.getListData,
      [this.channelActive, 'children', this.productActive, '_id'],
      '',
    );
  }
  @computed
  get slideActiveCode() {
    return lodash.get(
      this.getListData,
      [this.channelActive, 'children', this.productActive, 'categoryCode'],
      '',
    );
  }
  @computed
  get tabs() {
    return this.Model.get('tabs', []);
  }
  @computed
  get getListData() {
    return this.Model.get('data', []);
  }
  @computed
  get Labels() {
    return this.Model.get('Labels', []);
  }
  @computed
  get slideData() {
    return lodash.get(this.getListData, [this.channelActive, 'children']);
  }
  @computed
  get channelActive() {
    return this.Model.get('channelActive', 0);
  }

  @computed
  get productCategory() {
    return lodash.get(this.slideData, [this.productActive, 'alias'], '');
  }
  @computed
  get productActive() {
    return this.Model.get('productActive', 0);
  }
  @computed
  get cardDataSMB() {
    return this.Model.get('cardDataSMB', []);
  }
  @computed
  get cardDataRelOrIsg() {
    return this.Model.get('cardDataRelOrIsg', []);
  }
  @computed
  get currentBu() {
    return this.Model.get('currentBu', '');
  }
  setCurrentBu(bu) {
    this.Model.merge({ currentBu: bu });
  }
  setProductActive(index) {
    this.Model.merge({ productActive: index });
  }
  setChannelActive(index, isInitProductActive = true) {
    if (isInitProductActive) {
      this.Model.merge({ channelActive: index, productActive: 0 });
    } else {
      this.Model.merge({ channelActive: index });
    }
  }

  /**
   * @dec 获取 多渠道BU列表
   *
   */
  async onGetChannelsList() {
    const result = await AjaxBasics.request<Array<any>>({
      ...EnumAPI.product_channels_list,
      body: { source: this.currentBu },
    });

    let { tabs, list } = this.formatData(result);
    // console.log(list,"::::,,,,List,,,,",this.channelActive,'::::CA',this.productActive,':::,,PA')
    this.Model.merge({ data: list, tabs });
  }
  /**
   * @dec label筛选label
   * */
  async onGetLabels(params) {
    let result = await AjaxBasics.request<Array<any>>({
      ...EnumAPI.product_label,
      ...{ body: params },
    });
    this.Model.merge({ Labels: lodash.get(result, 'goodsParameterDTOS', []) });
  }
  /**
   * @dec 多渠道搜索
   *
   */
  async onChannelSearch(params) {
    return await AjaxBasics.request<Array<any>>({
      ...EnumAPI.product_channels_search,
      ...{ body: params },
    });
  }

  formatData(res) {
    if (!res) return;
    let buTypes = ['smb', 'rel', 'isg', 'con', 'ssg_a'];
    let currBu = this.currentBu.toLocaleLowerCase();
    let index = lodash.indexOf(buTypes, currBu);
    let arr = index > -1 ? lodash.take(res) : lodash.take(res, 3);
    let data = lodash.cloneDeep(arr);
    let tabsData = [];
    for (let i = 0; i < data.length; i++) {
      tabsData.push({
        title: lodash.get(data[i], 'alias', ''),
        categoryCode: lodash.get(data[i], 'categoryCode', ''),
        id: i,
      });
    }
    // this.tabs = tabsData
    if (currBu == 'smb' || currBu == 'con' || index == -1) {
      data[0] = this.formatSMDData(data[0]);
      data[1] = this.formatSMDData(data[1]);
    }
    return {
      tabs: tabsData,
      list: index > -1 ? lodash.fill(Array(3), data[0]) : data,
    };
    // this.channelData = data
  }
  formatSMDData(data) {
    let series = lodash.cloneDeep(data);

    let children = lodash.get(series, 'children', []);
    let newChildren = lodash.map(children, (item) => {
      let nextChildren = lodash.get(item, 'children', []);
      lodash.assign(item, {
        id: item.categoryCode,
        text: item.alias,
        _id: item.id,
      });
      if (lodash.size(nextChildren)) {
        item.children = lodash.concat(
          [
            {
              alias: '全部',
              categoryCode: item.categoryCode,
              className: 'none',
              text: item.alias,
            },
          ],
          nextChildren,
        );
        return this.formatSMDData(item);
      }
      return lodash.assign(item, { children: nextChildren });
    });
    return lodash.assign(series, { children: newChildren });
  }
}
